import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import _ from 'lodash'
import {socket} from "../../lib/socketio";
import {createUserLog} from "../../lib/api";
import {useSelector} from "react-redux";
import {isAuthorized} from "../../lib/authorization";


const FuelPropsColumn = ({index, column, data, dataCopy, setDataCopy, ngoverrides, setngoverrides, lpgoverrides, setlpgoverrides, fuelfactoverrides, setfuelfactoverrides}) => {

    const [open, setOpen] = React.useState(false);
    const [checkdata, setcheckdata]= React.useState('');
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const [log, setLog]= React.useState('');

    const handleOpen = (event, id) => {
        setOpen({...open, [id]:true});
    };

    const handleClose = (event, id) => {
        setOpen({...open, [id]:false});
    };

    const handleChange = (event, {value}, id, type) => {
        event.preventDefault();
        setDataCopy({...dataCopy, [id]: value});
        if (type === 'NG FUEL PROPERTY FACTORS') {
            setngoverrides({...ngoverrides, [id]: Number(value)});
        } else if (type === 'LPG FUEL PROPERTY FACTORS') {
            setlpgoverrides({...lpgoverrides, [id]: Number(value)});
        } else if (type === 'FUEL PROPERTY FACTORS') {
            setfuelfactoverrides({...fuelfactoverrides, [id]: Number(value)});
        }
    }


    const getValue = (parm,name) => {
        if(parm === 1) {
            return 'Enable'
        }
        else {
            return 'Disable'
        }
    };


    const handleCheck = (event, obj_key, display_id) => {
        if( event.target.id === "1") {
            setcheckdata(1);
            setDataCopy({...dataCopy, [obj_key]: 1});
            if(!electronApp){
                setLog({'user_id': user.id, 'powerplant_id': ppid, 'display_id': display_id, 'datetime': new Date().toISOString(), data: JSON.stringify({'tag_id': [obj_key]}) })
            }
        }
        else if( event.target.id === "0"){
            setcheckdata(0);
            setDataCopy({...dataCopy, [obj_key]: 0});
            if(!electronApp){
                setLog({'user_id': user.id, 'powerplant_id': ppid, 'display_id': display_id, 'datetime': new Date().toISOString(), data: JSON.stringify({'tag_id': [obj_key]}) })
            }
        }
    }

    const handleToggle = (event, id) => {
        event.preventDefault();
        if(typeof checkdata === 'undefined' || checkdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': checkdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]: false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        setcheckdata('');
    }


    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <Grid columns='equal' style={styles.grid}>
                <h3>{column[i][0].tag_display_subgroup}</h3>
                {column[i].map(r =>
                    <Grid.Row style={{paddingBottom: '0'}}>
                        <Grid.Column width={6} style={styles.name}>{r.tag_display_name} </Grid.Column>
                        {
                            r.tag_display_subgroup === 'FUEL CALCULATIONS' ?
                                r.name.slice(5, 9) === 'OPT_' ?
                                    <Grid.Column style={styles.read}>
                                        <Button
                                            key='button'
                                            content={getValue(data[r.id])}
                                            inverted color={data[r.id] === 1 ? 'green' : 'yellow'}
                                            disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                            onClick={() => {
                                                setOpen({...open, [r.id]: true})
                                            }}/>
                                        <Modal
                                            key={r.id}
                                            style={styles.width}
                                            open={open[r.id]}
                                            onClose={handleClose[r.id]}
                                            onOpen={handleOpen[r.id]}>
                                            <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                            <Modal.Content>
                                                <Input
                                                    type='radio'
                                                    id={1}
                                                    label='Enable'
                                                    checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 1 : ''}
                                                    onChange={(event, value) => handleCheck(event, r.id, r.display_id)}
                                                    style={styles.checkbox1}
                                                />
                                                <Input
                                                    type='radio'
                                                    id={0}
                                                    label='Disable'
                                                    checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 0 : ''}
                                                    onChange={(event, value) => handleCheck(event, r.id, r.display_id)}
                                                    style={styles.checkbox1}
                                                />
                                            </Modal.Content>
                                            <Modal.Actions style={styles.toggle}>
                                                <Button color='blue' content={'Ok'}
                                                        onClick={(event, value) => handleToggle(event, r.id)}/>
                                                <Button color='red' content={'Cancel'}
                                                        onClick={() => {
                                                            setOpen({...open, [r.id]: false})
                                                        }}/>
                                            </Modal.Actions>
                                        </Modal>
                                    </Grid.Column>
                                    :
                                    <Grid.Column style={styles.read}> {data[r.id]}</Grid.Column>
                                :
                                <>
                                    <Grid.Column width={2}>
                                        <Input focus
                                               style ={{width: '100px'}}
                                               name='Input change'
                                               type='number'
                                               step='0.0001'
                                               size='small'
                                               min={r.min}
                                               max={r.max}
                                               onChange={(event, value) => handleChange(event, value, r.id, r.tag_display_subgroup)}
                                               value={typeof dataCopy !== 'undefined' ? dataCopy[r.id] : ''}
                                        />
                                    </Grid.Column>
                                    <Grid.Column style={styles.read} width={17}>{data[r.id]}</Grid.Column>
                                </>
                        }
                    </Grid.Row>
                )}
            </Grid>
        ))
    ));

    return (
        <Grid.Column key={index} style={{maxWidth: '1400px', padding: '10'}}>
            {gridColumn}
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    width: {
        maxWidth: '400px'
    },
    name: {
        color: 'yellow'
    },
    read: {
        marginLeft: '100px'
    },
    checkbox1: {
        flexDirection: 'row-reverse',
    }
};

export default React.memo(FuelPropsColumn);

